module.exports = "<div class=\"docs\">\r\n    <p class=\"stock-triage-msg\">Coming soon...</p>\r\n</div>\r\n\r\n"